import { Badge, MantineSize } from "@mantine/core";
import { carColorsContrastMap, carColorsMap } from "utils/colors";

const VehicleColorBadge: React.FC<{color:string,size?: MantineSize}> = ({color,size="lg"}) => {
    return (
        <Badge size={size} styles={{ root: { border: '1px solid #333', backgroundColor: carColorsMap[color] }, inner: { fontWeight: 500, color: carColorsContrastMap[color] } }}>{color}</Badge>
    )
}

export default VehicleColorBadge;